import styled from 'styled-components';
import { theme } from '../../tokens/theme';

export const CenteredPage = styled.div`
  background-color: ${theme.light.ui.background.light};
  display: grid;
  place-items: center;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1rem;
  min-width: 30vw;

  > div {
    width: 100%;
  }
`;
